module.exports = __webpack_public_path__ + "static/media/sup-jobsite.85c16d86.jpg";